import { Lrud } from 'lrud';

const nav = new Lrud();

nav.registerNode('root', { orientation: undefined });

export default nav;
